import Textarea, { TextareaProps as _TextareaProps } from './Textarea';

export { Textarea };
export type TextareaProps = _TextareaProps;
